// extracted by mini-css-extract-plugin
export default {"goToSiteButton":"HB7KUe"};